<template>
    <layout title="Cottonseed Bid Acceptance">
        <div class="px-8">
            <div class="lg:grid lg:grid-cols-12 bg-green-50 mb-8">
                <div class="px-6 py-4 lg:col-span-3 text-center">
                    <div class="text-green-900 text-2xl mb-1 font-mono font-medium" v-if="item.quantity > 0">{{ item.quantity  }}</div>
                    <div v-if="item.percentage > 0">
                        <p class="text-gray-reen text-2xl mb-1 font-mono font-medium">{{ item.percentage_to_tons  }}</p>
                        <p class="text-sm text-green-700">{{ item.percentage }}% of {{ item.total_bale_estimate }} Est. Bales</p>
                    </div>
                    <div class="text-xs font-medium text-green-500 uppercase tracking-wider">Quantity Accepted</div>
                </div>
                <div class="px-6 py-4 lg:col-span-6 text-center">
                    <div class="text-green-900 text-2xl mb-1 font-mono font-medium">{{ item.gin.user.name  }}</div>
                    <div class="text-xs font-medium text-green-500 uppercase tracking-wider">Gin Name</div>
                </div>
                <div class="px-6 py-4 lg:col-span-3 text-center">
                    <div class="text-green-900 text-2xl mb-1 font-mono font-medium">{{ item.gin.lawson_number  }}</div>
                    <div class="text-xs font-medium text-green-500 uppercase tracking-wider">Gin Number</div>
                </div>
            </div>
            <div class="lg:grid lg:grid-cols-12 bg-gray-50">
                <div class="px-6 py-4 lg:col-span-3 text-center">
                    <div class="text-gray-900 text-2xl mb-1 font-mono font-medium">{{ item.bid.quantity  }}</div>
                    <div class="text-xs font-medium text-gray-500 uppercase tracking-wider">Quantity</div>
                </div>
                <div class="px-6 py-4 lg:col-span-3 text-center">
                    <div class="text-gray-900 text-2xl mb-1 font-mono font-medium">${{ item.bid.price | currency  }}</div>
                    <div class="text-xs font-medium text-gray-500 uppercase tracking-wider">Bid Price</div>
                </div>
                <div class="px-6 py-4 lg:col-span-6 text-center">
                    <div class="text-gray-900 text-2xl mb-1 font-mono font-medium">{{ item.bid.expires_at | niceTimestamp  }}</div>
                    <div class="text-xs font-medium text-gray-500 uppercase tracking-wider">Expiration</div>
                </div>
            </div>
            <div class="lg:grid lg:grid-cols-12 mt-4 border-dashed border-b-4 border-gray-200 pb-4">
                <div class="px-6 py-4 lg:col-span-4">
                    <dt class="text-sm font-medium text-gray-500">
                        Transport
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                        {{ item.bid.transport }}
                    </dd>
                </div>
                <div class="px-6 py-4 lg:col-span-4">
                    <dt class="text-sm font-medium text-gray-500">
                        Shipment Period
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                        {{ item.bid.shipment_period }}
                    </dd>
                </div>
                <div class="px-6 py-4 lg:col-span-4">
                    <dt class="text-sm font-medium text-gray-500">
                        Location
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                        {{ item.bid.location }}
                    </dd>
                </div>
                <div class="px-6 py-4 lg:col-span-12">
                    <dt class="text-sm font-medium text-gray-500">
                        Comments
                    </dt>
                    <dd class="mt-1 text-sm text-gray-900">
                        {{ item.bid.comments }}
                    </dd>
                </div>
            </div>
        </div>
    </layout>
</template>

<script>
import Layout from "@/Shared/Layout";

export default {
    components: {Layout},
    props: {
        item: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>

</style>
